import { render, staticRenderFns } from "./StoryCategories.vue?vue&type=template&id=45c6cac8&scoped=true&"
import script from "./StoryCategories.vue?vue&type=script&lang=js&"
export * from "./StoryCategories.vue?vue&type=script&lang=js&"
import style0 from "./StoryCategories.vue?vue&type=style&index=0&id=45c6cac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6cac8",
  null
  
)

export default component.exports